export const CONTRACT_TYPES = {
  1: 'Contract',
  2: 'Contract to Hire'
}

export const CONTRACT = 1
export const CONTRACT_TO_HIRE = 2
